import { createReducer } from "@reduxjs/toolkit";
import { getChildCampaigns } from "./actions";
import { ChildCampaignsState, initialState } from "./types";

export default createReducer(initialState as ChildCampaignsState, builder => {
  builder
    .addCase(getChildCampaigns.pending, state => {
      state.pending = true;
    })
    .addCase(getChildCampaigns.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload;
    })
    .addCase(getChildCampaigns.rejected, state => {
      state.pending = false;
      state.error = true;
    })
});
